import React from "react"
import { Controller, useFormContext } from "react-hook-form"
import { CurrencyList, ArtPieceSaleStatus } from "../../../api/Definitions"
import FormInput from "../../../components/Form/Inputs/FormInput"
import SelectInput from "../../../components/Form/Select/Select"

const currencyOptions = CurrencyList.map((x) => ({ value: x, label: x }))

const ArtPieceSaleInfo = () => {
  const { watch } = useFormContext()

  const { shrStatus } = watch(["shrStatus"])
  return (
    <>
      <Controller
        as={SelectInput}
        name="shrStatus"
        options={ArtPieceSaleStatus}
        label="Sale Status"
        placeholder="Select sale status..."
      />
      {shrStatus && (
        <>
          <FormInput name="shrPrice" label="Price" />
          <Controller
            as={SelectInput}
            name="shrCurrency"
            label="Currency"
            placeholder="Select currency..."
            options={currencyOptions}
          />
        </>
      )}
    </>
  )
}

export default ArtPieceSaleInfo
